const RESERVED_LABELS = new Set([
  "www",
  "api",
  "admin",
  "app",
  "mail",
  "cdn",
  "static",
  "assets",
  "staging",
  "dev",
  "test",
]);

function hostnameOnly(host) {
  return String(host || "")
    .toLowerCase()
    .split(":")[0]
    .replace(/\.$/, "");
}

function isIpv4(host) {
  return /^\d{1,3}(\.\d{1,3}){3}$/.test(host);
}

/**
 * True on the public SmartTT brand site (apex / www / OVH dev / localhost).
 * False on white-label club hosts like eschabol.smartttclub.com.
 */
export function isApexMarketingHost(host) {
  const hostname =
    host != null
      ? hostnameOnly(host)
      : typeof window !== "undefined"
        ? hostnameOnly(window.location.hostname)
        : "";

  if (!hostname || hostname === "localhost" || hostname === "127.0.0.1") {
    return true;
  }
  if (isIpv4(hostname)) return true;
  if (hostname.includes("googleapis.com") || hostname.includes("cloudfront.net")) {
    return true;
  }
  if (hostname === "smartttclub.com" || hostname === "www.smartttclub.com") {
    return true;
  }
  if (hostname === "dev.smartttclub.com") return true;

  if (hostname.endsWith(".dev.smartttclub.com")) {
    const sub = hostname.slice(0, -".dev.smartttclub.com".length);
    if (sub && !sub.includes(".") && !RESERVED_LABELS.has(sub)) return false;
    return true;
  }

  if (hostname.endsWith(".smartttclub.com")) {
    const sub = hostname.slice(0, -".smartttclub.com".length);
    if (sub && !sub.includes(".") && !RESERVED_LABELS.has(sub)) return false;
  }

  return true;
}
